var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPreview = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Preview",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2, 2)",
    stroke: "#0A186E",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 12.5,
    height: 12.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "remove_red_eye/Outlined",
    transform: "translate(2, 4.5)",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,1.2 C9.41181816,1.2 11.5627271,2.47800007 12.6127271,4.5 C11.5627271,6.52199993 9.41818179,7.8 7,7.8 C4.58181821,7.8 2.43727275,6.52199993 1.38727277,4.5 C2.43727275,2.47800007 4.58818184,1.2 7,1.2 Z M7,0 C3.81818182,0 1.1009091,1.86600008 0,4.5 C1.1009091,7.13399992 3.81818182,9 7,9 C10.1818182,9 12.8990909,7.13399992 14,4.5 C12.8990909,1.86600008 10.1818182,0 7,0 Z M7,3 C7.87818182,3 8.59090909,3.672 8.59090909,4.5 C8.59090909,5.328 7.87818182,6 7,6 C6.12181818,6 5.40909091,5.328 5.40909091,4.5 C5.40909091,3.672 6.12181818,3 7,3 Z M7,1.8 C5.42181817,1.8 4.13636364,3.01199999 4.13636364,4.5 C4.13636364,5.98800001 5.42181817,7.2 7,7.2 C8.57818183,7.2 9.86363636,5.98800001 9.86363636,4.5 C9.86363636,3.01199999 8.57818183,1.8 7,1.8 Z",
    id: "Vector"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Preview.873534b5e67d031221bed49195c3af59.svg";